var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.shouldBeEmpty
    ? _c("div", { staticClass: "empty-bread" })
    : _c(
        "div",
        {
          staticClass: "page-top-component px-3",
          class: { "is-empty": _vm.isEmpty }
        },
        [
          _c(
            "div",
            { staticClass: "breadcrumbs-container" },
            [
              _vm._l(_vm.crumbs, function(crumb, index) {
                return [
                  crumb.links
                    ? _c(
                        "VMenu",
                        {
                          key: index,
                          staticClass: "crumb",
                          attrs: {
                            bottom: "",
                            offsetY: "",
                            lazy: "",
                            maxHeight: "80vh",
                            disabled: !crumb.links
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              key: crumb.name,
                              staticClass: "crumb-inner",
                              attrs: { slot: "activator" },
                              slot: "activator"
                            },
                            [
                              crumb.icon
                                ? _c("KmIcon", {
                                    staticClass:
                                      "font-light primary--text mr-2",
                                    attrs: { name: crumb.icon }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              crumb.statusIcon
                                ? _c(
                                    "StatusIcon",
                                    _vm._b(
                                      { staticClass: "mr-2" },
                                      "StatusIcon",
                                      crumb.statusIcon,
                                      false
                                    )
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "pr-2 crumb-name" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(crumb.name) +
                                    "\n          "
                                )
                              ]),
                              _vm._v(" "),
                              index !== _vm.crumbs.length - 1
                                ? _c(
                                    "VIcon",
                                    { staticClass: "font-light pr-2" },
                                    [
                                      _vm._v(
                                        "\n            mdi-chevron-right\n          "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "VList",
                            _vm._l(crumb.links, function(link, linkIndex) {
                              return _c(
                                "VListTile",
                                {
                                  key: linkIndex,
                                  attrs: {
                                    to: link.to,
                                    activeClass: link.activeClass
                                  }
                                },
                                [
                                  link.icon
                                    ? _c(
                                        "VListTileAction",
                                        { staticClass: "action-centered" },
                                        [
                                          _c("KmIcon", {
                                            attrs: { name: link.icon }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("VListTileTitle", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(link.title) +
                                        "\n            "
                                    )
                                  ])
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          key: index,
                          staticClass: "crumb crumb-inner",
                          on: {
                            click: function($event) {
                              return _vm.$router.push(crumb.to)
                            }
                          }
                        },
                        [
                          crumb.icon
                            ? _c("KmIcon", {
                                staticClass: "font-light primary--text mr-2",
                                attrs: { name: crumb.icon }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          crumb.statusIcon
                            ? _c(
                                "StatusIcon",
                                _vm._b(
                                  { staticClass: "mr-2" },
                                  "StatusIcon",
                                  crumb.statusIcon,
                                  false
                                )
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "pr-2 crumb-name" }, [
                            _vm._v(
                              "\n          " + _vm._s(crumb.name) + "\n        "
                            )
                          ]),
                          _vm._v(" "),
                          index !== _vm.crumbs.length - 1
                            ? _c("VIcon", { staticClass: "font-light pr-2" }, [
                                _vm._v(
                                  "\n          mdi-chevron-right\n        "
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                ]
              }),
              _vm._v(" "),
              _vm.$store.getters.isDemo
                ? _c(
                    "div",
                    {
                      staticClass:
                        "text--text primary demo-badge ml-2 px-3 py-1"
                    },
                    [_vm._v("\n      DEMO APPLICATION\n    ")]
                  )
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("PortalTarget", { attrs: { name: "page-options" } })
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }